import { atom } from 'jotai';
export const resetPasswordDataAtom = atom({
    cpf: '',
    method: 'email',
    accountData: null,
    deviceId: null,
});
